export default __webpack_public_path__ + "static/prod1-a1f38b9345b1377e97846fa42e077e62.jpg";